export default {
  getGlobalSettings: {
    method: 'get',
    url: '/settings'
  },
  updateGlobalSettings: {
    method: 'post',
    url: '/settings/update'
  },
  getGPSSettings: {
    method: 'get',
    url: '/settings/gps'
  },
  updateGPSSettings: {
    method: 'post',
    url: '/settings/gps'
  },
  updateConfigContSettings: {
    method: 'post',
    url: '/settings/config-cont/update'
  },
  updateTimesSettings: {
    method: 'put',
    url: '/settings/times'
  },
  updateCostSettings: {
    method: 'put',
    url: '/settings/cost'
  },
  updatePartnerSettings: {
    method: 'put',
    url: '/settings/partner'
  },
  updatePolicySettings: {
    method: 'put',
    url: '/settings/policy'
  },
  uploadCompanyLogo: {
    method: 'post',
    url: '/settings/upload-company-logo'
  },
  updateRouteSettings: {
    method: 'put',
    url: '/settings/route'
  },
  createBankAccount: {
    method: 'post',
    url: '/settings/bank-account'
  },
  listBankAccount: {
    method: 'post',
    url: '/settings/bank-account/list'
  },
  archiveBankAccount: {
    method: 'delete',
    url: '/settings/bank-account/archive'
  },
  deleteBankAccount: {
    method: 'delete',
    url: '/settings/bank-account'
  },
  editBankAccount: {
    method: 'put',
    url: '/settings/bank-account/ID'
  },
  getBankAccount: {
    method: 'get',
    url: '/settings/bank-account/ID'
  },
  findBankAccount: {
    method: 'get',
    url: '/settings/bank-account/find'
  }
}
